import {FormGroup} from "@angular/forms";
import {IWorkout} from "../../../shared/interfaces/IWorkout";
import {IPairedExerciseConfig, IWorkoutForm, PlaylistFormFactory} from "./WorkoutFormFactory";
import {EExerciseType} from "../../../shared/enums/EExerciseType";
import {IExerciseConfig} from "../../exercises/exercise-form/exercise-form.component";

export interface IWorkoutExercisePatched {
    id: string;
    name: string;
    sets: number;
    type: EExerciseType;
    config: IExerciseConfig & IPairedExerciseConfig;
    firstExercise?: IWorkoutExercisePatched;
    secondExercise?: IWorkoutExercisePatched;
}

export class WorkoutFormHelper {
    public static patchValue(formGroup: FormGroup<IWorkoutForm>, value: IWorkout): void {
       formGroup.controls.name.setValue(value.name);
       value.playlists.forEach(playlist => {
           const playlistForm = PlaylistFormFactory.create();
           playlistForm.controls.id.patchValue(playlist.id);
           playlistForm.controls.name.patchValue(playlist.name);
           playlistForm.controls.name.patchValue(playlist.name);
           playlistForm.controls.isAutomated.patchValue(playlist.isAutomated);
           playlistForm.controls.circuitSets.patchValue(playlist.circuitSets);
           playlistForm.controls.restTime.patchValue(playlist.restTime);
           playlistForm.controls.isCircuit.patchValue(playlist.isCircuit);
           formGroup.controls.playlists.push(playlistForm);
       })
    }
}
